export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_18-c48ee486909dd216fa7731eaec41e697.jpg";